var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F89521",
    fillRule: "evenodd",
    d: "M32.96 11.228l3.812 3.812 1.009-1.004c.51-.511.79-1.19.79-1.912a2.686 2.686 0 0 0-.796-1.91 2.683 2.683 0 0 0-1.909-.79h-.004c-.722.001-1.4.284-1.91.795l-.992 1.009zM19.983 24.2l3.816 3.817 11.966-11.954-3.828-3.83-11.954 11.967zm-.69 1.323l-1.606 4.777 4.79-1.595-3.183-3.182zM17.143 32h-.111a1.012 1.012 0 0 1-.921-.578 1.01 1.01 0 0 1-.042-.778l2.229-6.683a.793.793 0 0 1 .048-.103l.017-.032a.736.736 0 0 1 .101-.13L32.952 9.208a4.136 4.136 0 0 1 5.84 0c.78.78 1.21 1.818 1.21 2.92a4.1 4.1 0 0 1-1.21 2.92L24.288 29.544a.715.715 0 0 1-.122.097l-.038.022a.814.814 0 0 1-.099.044l-6.661 2.223a1.007 1.007 0 0 1-.226.05v.02zM8.759 8.109h15.09c.42 0 .76.343.76.765s-.34.765-.76.765H9.778a.247.247 0 0 0-.247.248v28.335c0 .136.11.247.247.247h28.335c.137 0 .248-.11.248-.247V24.151c0-.42.343-.76.765-.76s.765.34.765.76v15.09c0 .419-.343.759-.766.759H8.765A.762.762 0 0 1 8 39.234V8.874c0-.422.34-.765.76-.765z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.dd076324b42b0d4ed734a65c72e6d051.svg";
export { ForwardRef as ReactComponent };